import { ApolloError, useQuery } from "@apollo/client";
import { getValue } from "@clockwise/client-commons/src/util/errorable.util";
import { DateTime } from "luxon";
import { useEffect, useState } from "react";
import { BulkInviteEventMap } from "../types";
import { getSuggestedBulkInviteEvents } from "../utils/getSuggestedBulkInviteEvents";
import { BulkInviteEventsDocument } from "./__generated__/BulkInviteEvents.generated";

export const useBulkInvite = (onError?: (error: ApolloError) => void) => {
  const [events, setEvents] = useState<BulkInviteEventMap>({});
  const { data, loading } = useQuery(BulkInviteEventsDocument, {
    fetchPolicy: "no-cache", // needed to refetch suggestions when user goes back in onboarding
    variables: {
      week: DateTime.now()
        .plus({ week: 1 })
        .startOf("week")
        .minus({ day: 1 }) //startof week for luxon is monday, we need sunday
        .toFormat("yyyy-MM-dd"),
    },
    onError: (error) => {
      if (!!onError) {
        onError(error);
      }
    },
  });

  useEffect(() => {
    if (!!data) {
      const orgs = data.viewer.user?.orgs?.edges;
      const events = !!orgs ? getValue(orgs[0]?.node?.calculateSmartHoldsErrorable)?.events : [];
      const pendingInvites = !!orgs ? getValue(orgs[0]?.node?.pendingInvites)?.edges : [];

      const suggestedEvents = events
        ? getSuggestedBulkInviteEvents(events, pendingInvites ?? [])
        : {};

      setEvents(suggestedEvents);
    }
  }, [data]);

  return { events, loading };
};
